/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { CalendarHeaderCell as CalendarHeaderCellCore, type CalendarHeaderCellProps as CalendarHeaderCellCoreProps, type ContextValue, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';

interface CalendarHeaderCellProps extends Omit<CalendarHeaderCellCoreProps, 'style' | 'className'> {
  /** Whether the calendar header cell should be small. @default false */
  isSmall?: boolean;
  style?: stylex.StyleXStyles;
}

const CalendarHeaderCellContext = createContext<ContextValue<CalendarHeaderCellProps, HTMLTableCellElement>>({});

const CalendarHeaderCell = forwardRef((props: CalendarHeaderCellProps, ref: ForwardedRef<HTMLTableCellElement>) => {
  [props, ref] = useContextProps(props, ref, CalendarHeaderCellContext);

  const { style, children, isSmall = false, ...coreProps } = props;

  return (
    <CalendarHeaderCellCore ref={ref} {...stylex.props(styles.base, isSmall && styles.small, style)} {...coreProps}>
      {children}
    </CalendarHeaderCellCore>
  );
});

const styles = stylex.create({
  base: {
    padding: 8,
    boxSizing: 'border-box',
    color: $.textTertiary,
    fontFamily: 'Inter',
    fontFeatureSettings: 'liga off, clig off',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: -0.45,
    lineHeight: '18px',
    textAlign: 'center',
    height: 56,
    width: 56,
  },
  small: {
    height: 48,
    width: 43,
  }
});

export { CalendarHeaderCell, CalendarHeaderCellContext, type CalendarHeaderCellProps };
